module.exports = __webpack_public_path__ + "img/_old_logo.5c764a61.png";